<template>
  <div>
    <button @click="handleClick">同程测试任务</button>
  </div>
</template>
<script>
import { jumpPage } from '@/utils/mUtil'

export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    handleClick() {
      jumpPage('https://m.ly.com/app/links/web/main_TeQ3A15KiJ2WjbtM7R?url=https%3A%2F%2Fm.17u.cn%2Ftcnewpublic%2F%23%2Fmileage%3Fwvc5%3D1%26refid%3D2000551877%26tcwvclogin&wakeNew=1&wakeRetry=1&wakeNext=0&wakePwdId=0&wakeDS=1&wakeRefid=2000551877&wakeDIC=FFFFFF&wakePid=9786')
    }
  },
  computed: {

  },
}
</script>

<style lang="less">

</style>
